
import React, { useEffect, useState, useCallback } from "react";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Loader from "../../elements/Loader";
import { toast } from "react-toastify";
import { useDropzone } from 'react-dropzone';
import ApiService from "../../services/apiService";

export default function AddTag() {
    const params = useParams();
    const { id } = params;
    console.log(id)
    const [loading,setLoading]=useState(false);
    const navigate = useNavigate();
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const [initialValues,setInitialValues]=useState({
        name: "",
        type: "",
        isActive: "",
        displayOnFrontend: false,
        festiveDate: "",
        festiveEndDate: "",
        image: ""
      })

      const validationSchema = Yup.object().shape({
        name: Yup.string().required(),
        type: Yup.string().required(),
        festiveEndDate: Yup.string().test(
          'end-after-start',
          'End date cannot be before start date',
          function (value) {
            const { festiveDate } = this.parent;
            if (!value || !festiveDate) return true;
            return value >= festiveDate;
          }
        ),
      });

      const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
          setImageFile(file);
          setImagePreview(URL.createObjectURL(file));
        }
      };

      const { getRootProps, getInputProps } = useDropzone({ onDrop });

      const getTagById = useCallback(async () => {
        ApiService.get(`category/${id}`).then((data)=>{
            if(data?.data){

              const {name, type, isActive, displayOnFrontend, festiveDate, festiveEndDate, image} = data?.data;
              setInitialValues({
                name,
                type,
                isActive: isActive != null ? String(isActive) : "",
                displayOnFrontend: displayOnFrontend != null ? String(displayOnFrontend) : "",
                festiveDate: festiveDate || "",
                festiveEndDate: festiveEndDate || "",
                image: image || ""
              })
              if (image) {
                setImagePreview(image)
              }
            }
          }).catch((err)=>{
            console.log(err)
            setLoading(false)
          })
      }, [id]);

      useEffect( ()=>{
        if(id) getTagById();
      },[id, getTagById]);

      const onSubmit = async (values, { setSubmitting, setFieldValue }) => {
        try {
            let imageUrlToSave = values.image || '';

            // Upload image to S3 if a new image is selected
            if (imageFile) {
              const formData = new FormData();
              formData.append('file', imageFile);

              const uploadResponse = await ApiService.post('upload/image', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
              })
              imageUrlToSave = uploadResponse?.url;
              console.log('Image uploaded to S3:', imageUrlToSave);
              console.log('Full upload response:', uploadResponse);
            } else if (imagePreview) {
              // Preserve existing image URL if no new image uploaded
              imageUrlToSave = imagePreview;
            }

            const submissionValues = {
                ...values,
                image: imageUrlToSave,
                isActive: values.isActive === 'true',
                displayOnFrontend: values.displayOnFrontend === 'true'
            };

            console.log('Submitting category with values:', JSON.stringify(submissionValues, null, 2));
            console.log('Image field in values:', submissionValues.image);

            let response;
            if (id) {
                response = await ApiService.put(`/category/${id}`, submissionValues);
                console.log('Update response:', response);
                if (response.msg === 'success') {
                    toast.success("Tag Updated");
                }
            } else {
                response = await ApiService.post('/category', submissionValues);
                console.log('Create response:', response);
                if (response.msg === 'success') {
                    toast.success("New Tag Added");
                }
            }
            navigate('/tag', { replace: true });
        } catch (error) {
          console.error('Error saving tag:', error);
          toast.error('Failed to save tag. Please try again.');
        }
        setSubmitting(false)
      }

   return (
    <div className="row" key={initialValues}>
      {loading && <Loader />}
      

      <div className="col-xl-8 col-lg-12 offset-md-2" >
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">{id ? 'Edit' : 'Add'} Puja Category</h4>
          </div>
          <div className="card-body">
            <div className="basic-form">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize={true}
              >
                {({ isSubmitting,setFieldValue, values }) => (
                  <Form>
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <label className="form-label">Category Name</label>
                        <span className="text-red">*</span>
                        <Field
                          name="name"
                          type="text"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      <div className="mb-3 col-md-6">
                          <label className="form-label"> Type</label>
                          <span className="text-red">*</span>
                          <Field as="select"
                            name="type"
                            type="text"
                            className="form-control"
                          >
                            <option value="">Select Type</option>
                            <option value="occasion">Occasion</option>
                            <option value="deity">Deity</option>
                            <option value="festivities">Festivities</option>
                          </Field>
                          <ErrorMessage
                            name="type"
                            component="div"
                            className="error-message"
                          />
                        </div>
                        <div className="mb-3 col-md-6">
                          <label className="form-label"> Status</label>
                          <Field as="select"
                            name="isActive"
                            type="text"
                            className="form-control"
                            placeholder="Select Status"
                          >
                            <option value="">Select Status</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </Field>
                          <ErrorMessage
                            name="isActive"
                            component="div"
                            className="error-message"
                          />
                        </div>
                        <div className="mb-3 col-md-6">
                          <label className="form-label"> Display on Landing page</label>
                          <Field as="select"
                            name="displayOnFrontend"
                            type="text"
                            className="form-control"
                          >
                            <option value="">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Field>
                          <span>Enable for only display categorized puja</span>
                        </div>
                        {values?.type && (
                        <>
                        <div className="mb-3 col-md-6">
                          <label className="form-label">Category Image</label>
                          <div {...getRootProps()} className="border border-dashed border-gray-300 p-4 rounded mb-4 cursor-pointer">
                            <input {...getInputProps()} />
                            {imagePreview ? (
                              <img src={imagePreview} alt="Preview" className="max-w-full h-40 object-cover" width={200} height={200} />
                            ) : (
                              <p>Drag 'n' drop an image, or click to select one</p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 col-md-6">
                          <label className="form-label">Start Date</label>
                          <Field name="festiveDate" type="date" className="form-control" />
                          <ErrorMessage
                            name="festiveDate"
                            component="div"
                            className="error-message"
                          />
                        </div>
                        <div className="mb-3 col-md-6">
                          <label className="form-label">End Date</label>
                          <Field name="festiveEndDate" type="date" className="form-control" />
                          <ErrorMessage name="festiveEndDate" component="div" className="error-message" />
                        </div>
                        </>
                        )}
                     
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn btn-primary"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
   )
}